module.exports = __webpack_public_path__ + "static/media/chinese-cyclists-mobile.29c30f8c.jpg";